import Masonry from "masonry-layout";

const cardGrid = document.querySelectorAll('.masonry-cards-grid')
if ( cardGrid ) {
    cardGrid.forEach(grid => {
        let msnry = new Masonry(grid, {
          // options
            itemSelector: '.masonry-cards-grid__single',
            columnWidth: '.grid-sizer',
            gutter: '.gutter-sizer',
            percentPosition: true,
        });
    })
}



const featuredPostsGrid = document.querySelectorAll('.featured-posts-grid')
if ( featuredPostsGrid ) {
    featuredPostsGrid.forEach(grid => {
      // featured post row can sometime contain the less than 3 items,
      // in that case we wont call for masonry but we will just center align items
        if ( grid.classList.contains('is-masonry')) {
            let msnry = new Masonry(grid, {
              // options
                itemSelector: 'article',
                columnWidth: '.grid-sizer',
                gutter: '.gutter-sizer',
                percentPosition: true,
            });
        }

    })
}
